// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__aEF4e","welcomeNextButton":"Welcome_welcomeNextButton__Bu35H"};